import { CancelTokenSource } from 'axios';

import { DomainReference, Location } from '@rygen/rygen-ui/model';

import {
  LocationQuickSearchResult,
  LocationSearchCriteria,
  LocationSearchResult,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'bill-to';

type QuickSearchOptions = {
  includeAddressBook?: boolean;
  includeTrimble?: boolean;
  cancelToken?: CancelTokenSource;
};

export class BillToController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getBillToInvoicePayingPartyOptions(): Promise<DomainReference[]> {
    const response =
      await this.http.get<DomainReference[]>(`invoice-paying-party`);
    return response.data.map((val) => new DomainReference(val));
  }

  async search(payload: LocationSearchCriteria): Promise<LocationSearchResult> {
    const response = await this.http.post<LocationSearchResult>(
      'search',
      payload,
    );
    return new LocationSearchResult(response.data);
  }

  async quickSearch(
    searchText: string,
    {
      includeAddressBook = true,
      includeTrimble = false,
      cancelToken,
    }: QuickSearchOptions,
  ): Promise<Location[]> {
    const response = await this.http.post<LocationQuickSearchResult>(
      'quick-search',
      { searchText, includeAddressBook, includeTrimble },
      { cancelToken: cancelToken?.token },
    );

    return new LocationQuickSearchResult(response.data).results;
  }
}
